<template>
  <div
    class="column-content-tab"
    :class="{activiated:activiated}"
  >
    <button @click="onclick()">
      {{ textLabel ? textLabel : $t('沿革') }}
    </button>
  </div>
</template>
<script>
export default {
  name: "ColumnContentTab",
  props: {
    textLabel: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    activiated: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
.column-content-tab {
  @include flex_center;
  position: relative;
  height: 50px;
  width: 100%;
  color: var(--gray-700);
  &.activiated {
    color: var(--blue-500);
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 100%;
      border-radius: 1px;
      background-color: var(--blue-500);
    }
  }
  button {
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.43;
    letter-spacing: 1px;
    color: inherit;
  }
}
</style>